import { LifeBuoy } from 'lucide-react';

/* =====================================================================
   «Pedir ayuda a TI», flotante SOLO en teléfono · DIRECTRIZ-TICKETS F2
   =====================================================================
   En pantalla ancha este botón se movió a la CABECERA (junto a la campana)
   y a una entrada del menú: flotando abajo a la izquierda tapaba la barra
   lateral —«Cambiar contraseña» quedaba debajo— (hallazgo del dueño, 26 de
   septiembre de 2026). En el teléfono no hay barra lateral fija, así que
   aquí sí flota; abajo a la IZQUIERDA para no pisar «Preguntar» (que vive
   abajo a la derecha) ni la barra inferior.

   No maneja el modal: lo abre el AppShell (que lo comparte con el icono de
   la cabecera), así hay un solo formulario. Icono CON texto, nunca solo
   (usuario cero, punto 2). Objetivo táctil grande, a una mano.
   ===================================================================== */
export default function BotonReportar({ onAbrir }) {
  return (
    <button
      type="button"
      onClick={onAbrir}
      aria-label="Pedir ayuda a TI"
      className="md:hidden fixed bottom-4 left-4 z-40 flex min-h-[48px] items-center gap-2
                 rounded-full bg-[var(--color-marca)] px-4 py-3 text-sm font-semibold
                 text-white shadow-lg hover:opacity-95 print:hidden sin-imprimir
                 focus:outline-none focus:ring-2 focus:ring-offset-2
                 focus:ring-[var(--color-marca)]"
    >
      <LifeBuoy className="h-5 w-5 shrink-0" aria-hidden="true" />
      <span>Pedir ayuda</span>
    </button>
  );
}
